module.exports = __webpack_public_path__ + "static/media/resume-pic.b55af468.png";